import { PermissionGuard } from '@/features/auth';
import { Alert, Button } from '@/shared/components';
import { useForgotPassword } from '@/features/auth/hooks/useForgotPassword';

interface Props {
  email: string;
}

export function UserForgotPasswordPanel({ email }: Props) {
  const forgotPasswordMutation = useForgotPassword();

  const handleForgotPassword = () => {
    forgotPasswordMutation.mutate(
      { email },
      {
        onSuccess: () => {
          // No need for an additional success message since the hook-level toast will handle it.
        },
        onError: () => {
          // No need for an additional error message since the hook-level toast will handle it.
        },
      }
    );
  };

  return (
    <div className="space-y-2">
      <div className="space-y-2">
        <div>
          <h3 className="font-semibold mb-2">Password Reset</h3>
          <div className="flex items-start gap-4 justify-between">
            <p className="text-sm text-mp-muted">
              Send a password reset email to this user so they can set a new password and regain access if they are locked out.
            </p>
            <PermissionGuard permission={{ resource: 'user', action: 'edit' }}>
              <Button
                size="sm"
                onClick={handleForgotPassword}
                disabled={forgotPasswordMutation.isPending}
                className="whitespace-nowrap"
              >
                Send Password Reset Email
              </Button>
            </PermissionGuard>
          </div>
        </div>

        {/* Errors surface via the hook-level handleUserMutationError toast — no inline alert. */}

        {forgotPasswordMutation.isSuccess && (
          <Alert variant="success">
            <span>Password reset email has been sent successfully.</span>
          </Alert>
        )}
      </div>
    </div>
  );
}
